import React from 'react';
import { Icon } from './Icon.js';
export const IconGripDotsFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("circle", { cx: "6", cy: "8", r: "1", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "6", cy: "4", r: "1", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "2", cy: "8", r: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "2", cy: "4", r: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "10", cy: "8", r: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "10", cy: "4", r: "1", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconGripDotsFill12.js.map